import VerifiedPurchasesList from './components/VerifiedPurchasesList';
import { bindActionCreators } from 'redux';
import withRouter from 'react-router-dom/withRouter'
import values from 'lodash/values';
import get from 'lodash/get';
import { connect } from 'react-redux';

import {
  loadReceiptLineups,
    updateReceiptLineup,
  loadAgencies,
  loadBrands,
    loadCampaignsForAgency
} from '../../shared/redux/entities/actions'

function mapStateToProps(state,props){
    const brandId = props.brandId;
  const brands = values(state.entities.companies)
    .filter((b) => b.name && b.name.length > 0 && b.isBrand)
    .sort((a,b) => (a.name || '').localeCompare((b.name || '')))
    const rscans = values(get(state,['entities','receiptLineups'],{}))
        .map((r) => {
            r.brand = brands.filter((b) => b.id === r.brandId).shift() || {};
            r.agency = get(state,['entities','agencies', r.agencyId], {});
            return r;
        })

  return {
    receiptLineups: brandId ? rscans.filter((r) => r.brandId === brandId) : rscans,
    brands:brands,
      brandId: brandId,
    agencies:values(get(state,['entities','agencies'],{}))
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    loadReceiptLineups,
      updateReceiptLineup,
    loadAgencies,
    loadBrands
  },dispatch);
}

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(VerifiedPurchasesList));



// WEBPACK FOOTER //
// ./src/routes/VerifiedPurchasesList/index.js